import { Directive, ElementRef, HostListener } from '@angular/core';
import { AppStateService } from 'core/app-state/app-state.service';

@Directive({
  selector: 'img[appImageFallback]',
  standalone: false
})
export class ImageFallbackDirective {

  constructor(
    private eRef: ElementRef,
    private appStateService: AppStateService
  ) {}

  @HostListener('error')
  loadFallbackOnError() {
    const element: HTMLImageElement = this.eRef.nativeElement as HTMLImageElement;
    if (this.appStateService.state.isElectron) {
      element.src = '/Program%20Files/Snapon%20IMPACT/snapon-impact-win32-x64/resources/app/assets/images/imageFallback.jpg';
    } else {
      element.src = '/assets/images/imageFallback.jpg';
    }
  }

}
